(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parvano-cart"] && !Shopify.designMode) return;
  try {
    
(() => {
  const status = document.querySelector('[data-cart-status]');
  const setQuantity = async (line, quantity) => {
    if (status) status.hidden = false;
    try {
      const response = await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({line:line,quantity:quantity})
      });
      if (!response.ok) throw new Error('Cart update failed');
      window.location.reload();
    } catch (error) {
      if (status) {
        status.hidden = false;
        status.textContent = 'COULD NOT UPDATE BAG — TRY AGAIN';
      }
    }
  };

  const checkoutForm = document.querySelector('[data-pv-checkout-form]');
  const checkoutButton = document.querySelector('[data-pv-checkout]');

  checkoutForm?.addEventListener('submit', () => {
    if (checkoutButton) {
      checkoutButton.disabled = true;
      checkoutButton.textContent = 'OPENING SECURE CHECKOUT…';
    }
  });

  document.querySelectorAll('[data-cart-line]').forEach(row => {
    const line = Number(row.dataset.cartLine);
    const input = row.querySelector('[data-cart-quantity]');
    const minus = row.querySelector('[data-cart-minus]');
    const plus = row.querySelector('[data-cart-plus]');
    const remove = row.querySelector('[data-cart-remove]');
    minus?.addEventListener('click', () => setQuantity(line, Math.max(0, Number(input.value || 0) - 1)));
    plus?.addEventListener('click', () => setQuantity(line, Number(input.value || 0) + 1));
    remove?.addEventListener('click', () => setQuantity(line, 0));
    input?.addEventListener('change', () => setQuantity(line, Math.max(0, Number(input.value || 0))));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parvano-editorial-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const items = document.querySelectorAll('[data-pv-reveal]');
  if (!items.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: .12 });
  items.forEach((item) => observer.observe(item));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parvano-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const openMenu = document.querySelector('[data-pv-menu]');
  const closeMenu = document.querySelector('[data-pv-close]');
  const drawer = document.querySelector('[data-pv-drawer]');
  const searchToggle = document.querySelector('[data-pv-search-toggle]');
  const searchBar = document.querySelector('[data-pv-search]');

  const setMenu = (open) => {
    if (!drawer || !openMenu) return;
    drawer.hidden = !open;
    openMenu.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('pv-nav-open', open);
  };

  openMenu?.addEventListener('click', () => setMenu(true));
  closeMenu?.addEventListener('click', () => setMenu(false));
  drawer?.addEventListener('click', (event) => {
    if (event.target === drawer) setMenu(false);
  });

  searchToggle?.addEventListener('click', () => {
    if (!searchBar) return;
    searchBar.hidden = !searchBar.hidden;
    if (!searchBar.hidden) searchBar.querySelector('input')?.focus();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parvano-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-pv-command]');
  if (!root) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion) {
    root.addEventListener('pointermove', (event) => {
      const x = (event.clientX / window.innerWidth - 0.5) * 2;
      const y = (event.clientY / window.innerHeight - 0.5) * 2;
      root.style.setProperty('--mx', x.toFixed(3));
      root.style.setProperty('--my', y.toFixed(3));
    });
  }

  const toast = root.querySelector('[data-pv-home-toast]');
  root.querySelectorAll('[data-pv-quick-add]').forEach(form => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (!button || button.disabled) return;
      const data = new FormData(form);
      const id = Number(data.get('id'));
      const quantity = Number(data.get('quantity') || 1);
      const old = button.textContent;
      button.disabled = true;
      button.textContent = 'PROCESSING…';
      try {
        const response = await fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:id,quantity:quantity}]})
        });
        if (!response.ok) throw new Error('Add failed');
        const cartResponse = await fetch('/cart.js', {headers:{'Accept':'application/json'}});
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-pv-cart-count]').forEach(el => el.textContent = cart.item_count ? ' (' + cart.item_count + ')' : '');
        button.textContent = 'ADDED';
        if (toast) toast.hidden = false;
        setTimeout(() => { button.textContent = old; button.disabled = false; }, 1000);
        setTimeout(() => { if (toast) toast.hidden = true; }, 3200);
      } catch (error) {
        button.textContent = 'TRY AGAIN';
        button.disabled = false;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parvano-motion-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-pv-motion]').forEach((root) => {
    if (root.dataset.pvReady === 'true') return;
    root.dataset.pvReady = 'true';

    const products = Array.from(root.querySelectorAll('[data-pv-product]'));
    const navItems = Array.from(root.querySelectorAll('[data-pv-nav]'));
    const stage = root.querySelector('[data-pv-stage]');
    const currentLabel = root.querySelector('[data-pv-current]');
    const totalLabel = root.querySelector('[data-pv-total]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!products.length || !stage) return;

    let activeProduct = 0;
    let pointerId = null;
    let interacting = false;
    let autoplayTimer = null;

    const framesFor = (product) => Array.from(product.querySelectorAll('[data-frame-index]'));

    const setFrame = (product, index) => {
      const frames = framesFor(product);
      if (!frames.length) return;
      const normalized = ((index % frames.length) + frames.length) % frames.length;
      frames.forEach((frame, frameIndex) => {
        frame.classList.toggle('is-active', frameIndex === normalized);
      });
      product.dataset.frame = String(normalized);
    };

    const showProduct = (index) => {
      const normalized = ((index % products.length) + products.length) % products.length;
      activeProduct = normalized;

      products.forEach((product, productIndex) => {
        const active = productIndex === normalized;
        product.hidden = !active;
        product.classList.toggle('is-active', active);
      });

      navItems.forEach((item, itemIndex) => {
        const active = itemIndex === normalized;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (currentLabel) currentLabel.textContent = String(normalized + 1).padStart(2, '0');
      const product = products[normalized];
      setFrame(product, Number(product.dataset.frame || 0));
    };

    if (totalLabel) totalLabel.textContent = String(products.length).padStart(2, '0');

    navItems.forEach((item) => {
      item.addEventListener('click', () => showProduct(Number(item.dataset.pvNav || 0)));
    });

    const scrub = (event) => {
      const product = products[activeProduct];
      const frames = framesFor(product);
      if (frames.length < 2) return;
      const rect = stage.getBoundingClientRect();
      const progress = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
      setFrame(product, Math.round(progress * (frames.length - 1)));
    };

    stage.addEventListener('pointerdown', (event) => {
      interacting = true;
      pointerId = event.pointerId;
      stage.setPointerCapture(pointerId);
      scrub(event);
    });

    stage.addEventListener('pointermove', (event) => {
      if (event.pointerType === 'mouse' || event.pointerId === pointerId) scrub(event);
    });

    const releasePointer = () => {
      interacting = false;
      pointerId = null;
    };

    stage.addEventListener('pointerup', releasePointer);
    stage.addEventListener('pointercancel', releasePointer);
    stage.addEventListener('pointerleave', () => {
      if (pointerId === null) interacting = false;
    });

    const startAutoplay = () => {
      if (reduceMotion || autoplayTimer) return;
      autoplayTimer = window.setInterval(() => {
        if (interacting || document.hidden) return;
        const product = products[activeProduct];
        const frames = framesFor(product);
        if (frames.length < 2) return;
        setFrame(product, Number(product.dataset.frame || 0) + 1);
      }, 900);
    };

    const stopAutoplay = () => {
      if (!autoplayTimer) return;
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) startAutoplay();
        else stopAutoplay();
      });
    }, { threshold: 0.25 });

    observer.observe(stage);
    showProduct(0);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parvano-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mainImage = document.getElementById('pv-main-product-image');
  const thumbs = Array.from(document.querySelectorAll('[data-pv-thumb]'));
  const current = document.querySelector('[data-pv-current]');
  let activeIndex = 0;

  const showImage = (index) => {
    if (!mainImage || !thumbs.length) return;
    activeIndex = (index + thumbs.length) % thumbs.length;
    const url = thumbs[activeIndex].dataset.image;
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src = url;
    thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === activeIndex));
    if (current) current.textContent = String(activeIndex + 1);
  };

  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
  document.querySelector('[data-pv-prev]')?.addEventListener('click', () => showImage(activeIndex - 1));
  document.querySelector('[data-pv-next]')?.addEventListener('click', () => showImage(activeIndex + 1));

  const lightbox = document.querySelector('[data-pv-lightbox]');
  const lightboxImage = document.querySelector('[data-pv-lightbox-image]');
  mainImage?.addEventListener('click', () => {
    if (!lightbox || !lightboxImage) return;
    lightboxImage.src = mainImage.currentSrc || mainImage.src;
    lightbox.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  });
  document.querySelector('[data-pv-lightbox-close]')?.addEventListener('click', () => {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.documentElement.style.overflow = '';
  });
  lightbox?.addEventListener('click', (event) => {
    if (event.target === lightbox) {
      lightbox.hidden = true;
      document.documentElement.style.overflow = '';
    }
  });

  const dataEl = document.getElementById('pv-variant-data');
  const variantId = document.getElementById('pv-variant-id');
  const price = document.getElementById('pv-price');
  const compare = document.getElementById('pv-compare');
  const add = document.getElementById('pv-add-bag');

  if (dataEl && variantId) {
    const variants = JSON.parse(dataEl.textContent);
    const updateVariant = () => {
      const selected = Array.from(document.querySelectorAll('[data-pv-option]:checked'))
        .sort((a,b) => Number(a.dataset.pvOption) - Number(b.dataset.pvOption))
        .map(el => el.value);

      const variant = variants.find(v => v.options.every((option, index) => option === selected[index]));
      if (!variant) return;
      variantId.value = variant.id;
      if (price) price.textContent = variant.price;

      if (compare) {
        if (variant.compare && variant.compare !== variant.price) {
          compare.hidden = false;
          compare.textContent = variant.compare;
        } else {
          compare.hidden = true;
        }
      }

      if (add) {
        add.disabled = !variant.available;
        add.textContent = variant.available ? 'PRE-ORDER — ADD TO BAG' : 'SOLD OUT';
      }

      if (variant.image && mainImage) {
        const imageIndex = thumbs.findIndex(t => t.dataset.image.split('?')[0] === variant.image.split('?')[0]);
        if (imageIndex >= 0) showImage(imageIndex);
        else {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = variant.image;
        }
      }
    };
    document.querySelectorAll('[data-pv-option]').forEach(radio => radio.addEventListener('change', updateVariant));
  }

  const form = document.getElementById('pv-product-form');
  const toast = document.querySelector('[data-pv-added]');
  const toastClose = document.querySelector('[data-pv-added-close]');

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = document.getElementById('pv-add-bag');
    if (!button || button.disabled) return;

    const formData = new FormData(form);
    const id = Number(formData.get('id'));
    const quantity = Number(formData.get('quantity') || 1);
    button.disabled = true;
    const original = button.textContent;
    button.textContent = 'ADDING…';

    try {
      const response = await fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:id,quantity:quantity}]})
      });
      if (!response.ok) throw new Error('Unable to add item');

      const cartResponse = await fetch('/cart.js', {headers:{'Accept':'application/json'}});
      const cart = await cartResponse.json();
      document.querySelectorAll('[data-pv-cart-count]').forEach(el => {
        el.textContent = cart.item_count ? ' (' + cart.item_count + ')' : '';
      });

      if (toast) toast.hidden = false;
      button.textContent = 'ADDED';
      setTimeout(() => {
        button.textContent = original;
        button.disabled = false;
      }, 1000);
    } catch (error) {
      button.textContent = 'TRY AGAIN';
      button.disabled = false;
    }
  });

  toastClose?.addEventListener('click', () => { if (toast) toast.hidden = true; });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parvano-shop"] && !Shopify.designMode) return;
  try {
    
(() => {
  const toggle = document.querySelector('[data-filter-toggle]');
  const panel = document.querySelector('[data-filter-panel]');
  toggle?.addEventListener('click', () => panel?.classList.toggle('is-open'));

  const toast = document.querySelector('[data-pv-shop-toast]');
  document.querySelectorAll('[data-pv-shop-add]').forEach(form => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (!button || button.disabled) return;
      const data = new FormData(form);
      const id = Number(data.get('id'));
      const old = button.textContent;
      button.disabled = true;
      button.textContent = 'ADDING…';

      try {
        const response = await fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:id,quantity:1}]})
        });
        if (!response.ok) throw new Error('Add failed');

        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-pv-cart-count]').forEach(el => el.textContent = cart.item_count ? ' (' + cart.item_count + ')' : '');
        button.textContent = 'ADDED';
        if (toast) toast.hidden = false;
        setTimeout(() => { button.textContent = old; button.disabled = false; }, 900);
        setTimeout(() => { if (toast) toast.hidden = true; }, 3000);
      } catch (error) {
        button.textContent = 'TRY AGAIN';
        button.disabled = false;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
